import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfessorService {

  constructor(private http: HttpClient) { }

  getProfessors(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'api/v1/admin/professor/list', { withCredentials: true });
  }

  getProfessorSubjects(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'api/v1/professor/grading/subjects', { withCredentials: true });
  }

  getProfSubjectWorkItems(payload: any, subjectId: number): Observable<any> {
    let endpoint = `api/v1/professor/grading/subjects/work-items/${subjectId}/list`;

    if (payload)
      endpoint += `?period_id=${payload.period_id}&category_id=${payload.category_id}`;

    return this.http
      .get<any>(environment.apiUrl + endpoint, { withCredentials: true });
  }

  addProfessorSubjectWorkItem(payload: any, subjectId: number): Observable<any> {
    const endpoint = `api/v1/professor/grading/subjects/work-items/${subjectId}/add`;

    return this.http.put<any>(environment.apiUrl + endpoint, JSON.stringify(payload), { withCredentials: true });
  }

  updateProfessorSubjectWorkItem(payload: any, subjectId: number, id: number): Observable<any> {
    const endpoint = `api/v1/professor/grading/subjects/work-items/${subjectId}/update/${id}`;

    return this.http.patch<any>(environment.apiUrl + endpoint, JSON.stringify(payload), { withCredentials: true });
  }

  getWorkItemStudentsGrade(
    subjectId: number,
    componentId: number,
    categoryId: number,
    wokrItemId: number
  ): Observable<any> {
    let endpoint = `api/v1/professor/grading/subjects/work-items/grades/${subjectId}/add/${componentId}/${categoryId}/${wokrItemId}`;

    return this.http.get<any>(environment.apiUrl + endpoint, { withCredentials: true });
  }

  encodeWorkItemStudentsGrade(payload: any, subjectGradeId: number): Observable<any> {
    const endpoint = `api/v1/professor/grading/subjects/work-items/grades/store/${subjectGradeId}/bulk`;

    return this.http.post<any>(environment.apiUrl + endpoint, JSON.stringify(payload), { withCredentials: true });
  }

  getGradeDetailsReport(payload: any = null, subjectId: number) {
    let endpoint = `api/v1/professor/grading/subjects/work-items/grades/reports/${subjectId}/details/`;

    if (payload?.period_id && payload?.category_id)
      endpoint += `?period_id=${payload.period_id}&category_id=${payload.category_id}`;

    return this.http.get<any>(environment.apiUrl + endpoint, { withCredentials: true });
  }

  getProfSubjectStudents(subjectId): Observable<any> {
    return this.http.get<any>(environment.apiUrl + `api/v1/professor/grading/subjects/${subjectId}/students`, { withCredentials: true });
  }

  updateProfessorAvailability(professor_id: any, campus_id: any, payload: { availabilities: { day_available: string; period: string; publish: string }[] }): Observable<any> {
    return this.http.put<any>(
      environment.apiUrl + `api/v1/admin/professor/${professor_id}/availability/${campus_id}/batch`,
      JSON.stringify(payload),
      { withCredentials: true }
    );
  }
}